import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AdminDashboard from "../Dashboard/AdminDashboard";
import SubAdminDashboard from "../Dashboard/SubAdminDashboard";
import StudentDashboard from "../Dashboard/StudentDashboard";
import AgentDashboard from "../Dashboard/Agent-Dahsboard";
import SAgentDashboard from "../Dashboard/Sub-Agent-Dashboard";

const Dashboard = () => {
  const navigate = useNavigate();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    // Check authentication
    const userStr = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (!userStr || !token) {
      localStorage.clear();
      navigate("/");
      return;
    }

    // Decode and validate JWT token
    let payload;
    try {
      payload = JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      console.error("Invalid token format:", e);
      localStorage.clear();
      navigate("/");
      return;
    }

    // Check token expiry
    const timeLeft = payload.exp * 1000 - Date.now();
    if (timeLeft <= 0) {
      console.log("Token expired");
      localStorage.clear();
      navigate("/");
      return;
    }

    // Load correct dashboard based on user role
    const user = JSON.parse(userStr);
    const role = user?.role?.toLowerCase().replace(/\s+/g, "");

    switch (role) {
      case "admin":
        setComponent(<AdminDashboard />);
        break;
      case "subadmin":
        setComponent(<SubAdminDashboard />);
        break;
      case "student":
        setComponent(<StudentDashboard />);
        break;
      case "agent":
        setComponent(<AgentDashboard />);
        break;
      case "subagent":
        setComponent(<SAgentDashboard />);
        break;
      default:
        localStorage.clear();
        navigate("/unauthorized");
        return;
    }

    // Set up auto-logout when token expires
    const logoutTimer = setTimeout(() => {
      console.log("Token expired - logging out");
      localStorage.clear();
      navigate("/");
    }, timeLeft);

    // Listen for manual logout from other tabs
    const handleStorageChange = (event) => {
      // If token or user is removed from another tab, logout this tab too
      if (event.key === "token" && event.newValue === null) {
        console.log("Logged out from another tab");
        navigate("/");
      }
      if (event.key === "user" && event.newValue === null) {
        console.log("User data cleared from another tab");
        navigate("/");
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // Cleanup
    return () => {
      clearTimeout(logoutTimer);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);

  // Show loading state while component is being determined
  if (!component) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return <>{component}</>;
};

export default Dashboard;